import {management} from '../../../index.js' //api
import {RainfallRepository} from '../../infra/knex/repositories/rainfall'
import {SaveRainfallByTimeUseCase} from "./updateRainfallByTime"

export const updateMultiplesRainfallDataByTimeUseCase=new SaveRainfallByTimeUseCase(new RainfallRepository(management))
